import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import MoreActionsMenu, { MenuAction } from 'src/shared/components/more-actions-menu/MoreActionsMenu';

export type FileActionsMenuProps = {
    onRename: () => void;
    onDelete: () => void;
    isDeleteDisabled?: boolean;
    testId?: string;
};

const FileActionsMenu = (props: FileActionsMenuProps) => {
    const { onRename, onDelete, isDeleteDisabled = false, testId = 'file-actions-menu' } = props;

    const actions: MenuAction[] = [
        {
            label: 'Rename',
            onClick: onRename,
            icon: <Pencil className='w-5 h-5' />,
        },
        {
            label: 'Delete',
            onClick: onDelete,
            disabled: isDeleteDisabled,
            icon: <Trash2 className='w-5 h-5' />,
        },
    ];

    return <MoreActionsMenu actions={actions} testId={testId} side='right' align='start' />;
};

export default FileActionsMenu;
